<template>
  <div class="container-fluid">
    <!-- Header -->
    <div class="d-md-flex align-items-center">
      <div>
        <h3 class="card-title">Podsumowanie</h3>
        <h5 class="card-subtitle text-muted font-weight-normal">
          Informacje o koncie oraz saldzie
        </h5>
      </div>
    </div>
    <hr class="custom-hr" />
    <!-- Chart and Data Section -->
    <div class="row mb-5">
      <div
        class="col-lg-4 col-md-6 col-12 order-2 order-lg-first pl-4 mt-5 mt-lg-3"
        id="v-step-3"
        style="overflow:hidden"
      >
        <h3 class="card-title mt-4">Zaoszczędzone</h3>
        <h5
          class="card-subtitle text-muted font-weight-normal"
          style="max-width:50%"
        >
          Kwota zaoszczędzona dzięki kuponom
        </h5>
        <div>
          <vs-row class="mt-4 mb-1">
            <vs-col
              vs-lg="5"
              vs-xs="6"
              vs-sm="6"
              class="d-flex align-items-center"
            >
              <div>
                <div class="font-medium mb-0 h1" style="font-size: 2.75rem;">
                  {{ saved_money }}
                </div>
                <span class="h3 op-5 font-weight-normal">PLN</span>
              </div>
            </vs-col>
            <vs-col vs-lg="7" vs-xs="6" vs-sm="6">
              <div style="height:70px; position:relative;" class="mt-4 mb-4">
                <i class="mdi mdi-piggy-bank piggy-icon"></i>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </div>
      <div
        class="col-lg-4 col-md-12 text-center pl-2 order-1 order-lg-2 mt-2 mt-lg-3"
      >
        <h1 class="mb-0 mt-4">Witaj {{ name }} w panelu Klubu TVOkazje</h1>
        <h6 class="font-weight-light text-muted"></h6>
        <vs-row vs-align="center">
          <vs-col vs-lg="12" vs-sm="12" id="v-step-1">
            <h2 class="mt-4 mb-0">
              {{ saldo["available"] }}<i class="mdi mdi-coin text-warning"></i>
            </h2>
            <h4 class="font-weight-light text-muted">Dostępne puntky</h4>
            <br />
          </vs-col>
        </vs-row>
        <vs-row vs-align="center">
          <vs-col vs-lg="12" vs-sm="12">
            <vs-button
              color="warning"
              type="filled"
              icon="card_giftcard"
              style="width: 68%; font-size:19px; margin: auto 16%"
              id="v-step-2"
              @click="goToPointsExchange"
              >Wymień punkty na rabaty</vs-button
            >
          </vs-col>
        </vs-row>
      </div>

      <div
        class="col-lg-4 col-md-6 col-sm-12 col-xs-12 pl-4 order-3 mt-5 mt-lg-3"
      >
        <div class="pt-1 mt-4  ml-md-5 ml-sm-3">
          <span class="h2 d-block font-medium">Korzyści dla klubowicza</span>
          <vs-col vs-lg="12" vs-sm="12" class="text-left mt-2">
            <span style="font-size:19px;"
              ><i class="mdi mdi-truck-delivery"></i>&nbsp;Darmowa dostawa od
              199,90 zł</span
            ><br />
            <span style="font-size:19px;"
              ><i class="mdi mdi-gift"></i>&nbsp;Prezent za 1 zł</span
            ><br />
            <span style="font-size:19px;"
              ><i class="mdi mdi-sale"></i>&nbsp; 3 x bon 20 zł</span
            ><br />
            <span style="font-size:19px;"
              ><i class="mdi mdi-history"></i>&nbsp;100 dni na zwrot
              towaru</span
            ><br />
          </vs-col>
        </div>
        <!-- <ActiveVisitors :level="level"></ActiveVisitors> -->
      </div>
    </div>
    <!-- Footer -->
    <hr class="custom-hr" />
    <MonthlyProfitList
      :totalincomes="totalincomes"
      id="v-step-4"
    ></MonthlyProfitList>
  </div>
</template>
<script>
//import VueApexCharts from "vue-apexcharts";
//import ActiveVisitors from "../../dashboard-components/active-visitors/ActiveVisitors";
import MonthlyProfitList from "../monthly-profit-list/MonthlyProfitList";
export default {
  name: "Saldo",

  props: {
    name: {
      type: String,
      required: true
    },
    surname: {
      type: String,
      default: ""
    },
    email: {
      type: String,
      default: ""
    },
    saldo: {
      required: true
    },
    active_vouchers: {
      required: true
    },
    saldo_history: {
      required: true
    },
    saldo_labels: {
      required: true
    },
    saved_money: {
      required: true
    }
  },
  data: () => ({
    title: "Zmiany salda punktów",
    level: []
  }),
  components: {
    //VueApexCharts,
    MonthlyProfitList
    //ActiveVisitors
  },
  computed: {
    series: function() {
      return [
        {
          name: "Punkty dostępne",
          data: this.saldo_history
        }
      ];
    },
    chartOptions: function() {
      let options = {
        dataLabels: { enabled: false },
        chart: { toolbar: { show: false }, zoom: { enabled: false } },
        stroke: { curve: "smooth", width: 2 },
        colors: ["#4fc3f7", "#2962FF", "#f62d51", "#ffbc34", "#212529"],
        xaxis: {
          categories: this.saldo_labels,
          labels: { style: { cssClass: "text-muted fill-color" } }
        },
        yaxis: {
          labels: { style: { cssClass: "text-muted fill-color" } }
        },
        markers: { size: 3 },
        tooltip: {
          enabled: false,
          show: false
        },
        legend: { show: false },
        grid: {
          show: true,
          borderColor: "rgba(0,0,0,0.1)"
        }
      };
      return options;
    },
    totalincomes: function() {
      return [
        {
          gridlg: "vs-lg-2",
          gridsm: "vs-sm-6",
          iconcolor: "text-warning",
          icon: "mdi mdi-coin",
          textcolor: "text-dark",
          text: "Saldo punktów",
          money: this.saldo["available"],
          tooltip:
            "Saldo punktów to suma Twoich zdobytych punktów, możliwych do wykorzystania. Możesz je wymienić na kupony pieniężne lub prezentowe."
        },
        {
          gridlg: "vs-lg-2",
          gridsm: "vs-sm-6",
          iconcolor: "text-info",
          icon: "mdi mdi-receipt",
          textcolor: "text-dark",
          text: "Wydane punkty",
          money: this.saldo["spent"],
          tooltip: "Wydane punkty to suma punktów wymienionych na kupony."
        },
        {
          gridlg: "vs-lg-2",
          gridsm: "vs-sm-6",
          iconcolor: "text-primary",
          icon: "mdi mdi-lock",
          textcolor: "text-dark",
          text: "Zablokowane punkty",
          money: this.saldo["locked"],
          tooltip:
            "Zablokowane punkty to punkty, które zostaną odblokowane, gdy Twoja transakcja dobiegnie końca"
        },
        {
          gridlg: "vs-lg-2",
          gridsm: "vs-sm-6",
          iconcolor: "text-success",
          icon: "mdi mdi-cart-plus",
          textcolor: "text-dark",
          text: "Aktywne kupony rabatowe",
          money: this.active_vouchers,
          tooltip:
            "Aktywne kupony rabatowe możesz wykorzystać podczas zakupów telefonicznych oraz na stronie TVOkazje."
        }
      ];
    }
  },
  methods: {
    goToPointsExchange() {
      const offset =
        document.getElementById("v-points-step-0").getBoundingClientRect().top -
        70;
      window.scrollTo({
        top: offset,
        behavior: "smooth"
      });
    }
  }
};
</script>
